import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";

import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./visitorlogsbydate.component.html",
})
export class VisitorlogsbydateComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private userService: UserService,
		private dialogService: DialogService
	) {}

	/* Uses:
	 *  Facility
	 *  Start Date
	 *  End Date
	 *  Sort By (ASC or DESC)
	 */

	report = {
		SchoolID: 0,
		FacilityID: 0,
		SortBy: "Date Ascending",
		startDate: new Date(),
		endDate: new Date(),
		ImageLogo: "",
	};

	subscription: any;

	facilityList: any = [];
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ImageLogoList: any = [];

	lstSortBy = [
		{
			SortByDesc: "Date Ascending",
		},
		{
			SortByDesc: "Date Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 380;

	ngOnInit() {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadFacilityList() {
		var result = this.reportService.FacilitySelectList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.facilityList = response;

				this.facilityList.unshift({
					FacilityID: 0,
					FacilityName: "Any",
				});

				this.report.FacilityID = this.facilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	onSchoolChange(val) {
		this.report.SchoolID = val;
		this.loadFacilityList();
		this.loadLogolist();
	}

	/* Report Id = 380
	 * Parameters:
	 *    Facility (School ID)
	 *    Start Date
	 *    End Date
	 *    Sort By
	 *    Report Logo
	 *    User ID?
	 */

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.FacilityID) {
			this.errorMessage = "Select the Facility";
			return;
		}

		var strParam = this.GetStrParam();

		var reportID = 380;

		//SchoolID not used by SP
		var result = this.reportService.Print(reportID, strParam, 202, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		let current_user = this.userService.getCurrentUser();
		this.isProcessing = true;

		//1st Parameter /Facility ID
		var strParam = this.report.FacilityID + "|FacilityID";

		//2nd Parameter Start Date
		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");

		//3rd Parameter End Date
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";

		//4th Parameter Sort By
		strParam += "," + this.report.SortBy + "|ORDERBY";

		//5th Parameter Sort By
		strParam += "," + current_user.userID + "|UserID";

		//6th Parameter Report Logo
		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
